import axios from "axios";

const baseUrl = `${process.env.REACT_APP_GITO_API_URL}/Resources/AppPush`;

//const apiBaseUrl = "https://localhost:7241";

const authHeaders = (apiAccessToken) => ({
    "Content-Type": "application/json",
    Authorization: `Bearer ${apiAccessToken}`,
});

export async function listAppPushMessages(apiAccessToken, from, to) {
    const params = {};
    if (from) {
        params.from = from;
    }
    if (to) {
        params.to = to;
    }

    const response = await axios.get(baseUrl, {
        headers: authHeaders(apiAccessToken),
        params,
    });
    return response.data;
}

export async function getAppPushMessage(id, apiAccessToken) {
    const response = await axios.get(`${baseUrl}/${id}`, {
        headers: authHeaders(apiAccessToken),
    });
    return response.data;
}

export async function createAppPushMessage(payload, apiAccessToken) {
    const response = await axios.post(baseUrl, payload, {
        headers: authHeaders(apiAccessToken),
    });
    return response.data;
}
